/* =========================================================================
   Ripe & Ready — delivery date and postcode checking.

   Shared by the homepage strip and the box builder, so both always give the
   customer the same answer. Depends on rr-areas.js being loaded first.
   ========================================================================= */
(function () {
  "use strict";

  var DAY = 2; // Tuesday. Sunday is 0.

  /* Deliveries run every Tuesday, 10am to 5pm.
     Order on the Monday and you make the next day's run. Order ON a Tuesday
     and the van has already left, so the first box is the Tuesday after. */
  function nextDelivery() {
    var d = new Date();
    var add = (DAY - d.getDay() + 7) % 7;
    if (add === 0) {
      add = 7;
    }
    d.setDate(d.getDate() + add);
    return d;
  }

  function nextDeliveryText() {
    return nextDelivery().toLocaleDateString("en-AU", {
      weekday: "long",
      day: "numeric",
      month: "long"
    });
  }

  function areas() {
    return window.RR_AREAS || {};
  }

  function outside() {
    return window.RR_OUTSIDE || {};
  }

  /* Answers one postcode.
     Returns { ok, postcode, suburbs, near } where `near` lists suburbs that
     share the postcode but sit outside the run. */
  function check(pc) {
    pc = String(pc == null ? "" : pc).trim();
    if (!/^\d{4}$/.test(pc)) {
      return { ok: false, reason: "format", postcode: pc, suburbs: [], near: [] };
    }
    var inside = areas()[pc];
    if (!inside) {
      return { ok: false, reason: "out", postcode: pc, suburbs: [], near: [] };
    }
    return {
      ok: true,
      reason: "in",
      postcode: pc,
      suburbs: inside.slice(),
      near: (outside()[pc] || []).slice()
    };
  }

  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  window.RR = window.RR || {};
  window.RR.nextDelivery = nextDelivery;
  window.RR.nextDeliveryText = nextDeliveryText;
  window.RR.checkPostcode = check;
  window.RR.esc = esc;
})();
